import styled from 'styled-components'

const iconSize = '46px'

export default styled.div`
  position: absolute;
  top: ${(props) => props.top || '54px'};
  ${(props) => {
    if (props.right) return `right: ${props.right};`
    else return `right: calc((${props.width} / 2 - (${iconSize} / 2)) * -1);`
  }}
  z-index: var(--z-index-modal);
  user-select: none;

  .content {
    box-sizing: border-box;
    width: ${(props) => props.width};
    height: auto;
    border: 1px solid var(--color-elevated-border);
    border-radius: 6px;
    position: relative;
    background: var(--color-elevated);
    box-shadow: var(--color-elevated-shadow);
    cursor: default;
    &.dropdown {
      & > .dropdown-menu-item {
        padding: 8px 15px;
        border-radius: 6px;
        cursor: pointer;
        &:hover {
          background: var(--dropdown-hover) !important;
        }
      }
    }
  }
`
